import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Frieze } from '@/components/landing/frieze'

const Home: FC = (): ReactNode => {
    return (
        <Layout variant='immersive'>
            <Seo
                title='Work'
                description='Eight projects from Frieze — identity, typeface design, editorial, packaging and wayfinding.'
            />

            <div className='relative h-[100svh] w-full overflow-hidden'>
                <Frieze />
            </div>
        </Layout>
    )
}

export default Home
